import { render } from "./DropdownsContent.vue?vue&type=template&id=2687f1e4"
import script from "./DropdownsContent.vue?vue&type=script&lang=js"
export * from "./DropdownsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__